import React from "react";
import dateHelpers from "../../helpers/dateHelpers";
import { useHistory } from "react-router-dom";

const DayAppointments = props => {
    let history = useHistory();

    const onClick = schedule => {
        history.push(`/appointment/${schedule.id}/edit`);
    }

    return (
        <div>
            <div className="cts-appointment-day-header">{dateHelpers.getAppointmentDay(props.date, "en")}</div>
            {props.schedules.map(x =>
                <div onClick={() => onClick(x)} className="pf-schedule-appointment-container">
                    <div className="pf-schedule-date-container">
                        <span className="start">{dateHelpers.getTimeString(new Date(x.schedule.startTime * 1000), true)}</span> <br />
                        <span className="end">{dateHelpers.getTimeString(new Date(x.schedule.endTime * 1000), true)}</span>
                    </div>
                    <div className="pf-schedule-appointment-body">
                        {x.user.name}
                    </div>
                    <div className="pf-schedule-appointment-btns">
                        <i className="far fa-chevron-right" />
                    </div>
                </div>
            )}
        </div>
    )
}

export default DayAppointments;